/**
 * Role codes excluded from Create/Edit Employee Role dropdowns.
 * Matched by stable role_code from the API (not numeric role ids).
 * Other workflows keep the full assignable catalog.
 */
export const ROLE_KIOSK = 'KIOSK';
export const ROLE_TEAM_LEADER = 'TEAM_LEADER';

export const EMPLOYEE_FORM_EXCLUDED_ROLE_CODES = [
  ROLE_KIOSK,
  ROLE_TEAM_LEADER,
] as const;

/** @deprecated Prefer EMPLOYEE_FORM_EXCLUDED_ROLE_CODES; same codes for Create. */
export const CREATE_EMPLOYEE_EXCLUDED_ROLE_CODES = EMPLOYEE_FORM_EXCLUDED_ROLE_CODES;

/** Same exclusions as Create — Edit Employee Role dropdown only. */
export const EDIT_EMPLOYEE_EXCLUDED_ROLE_CODES = EMPLOYEE_FORM_EXCLUDED_ROLE_CODES;

export function normalizeRoleCode(roleCode: string | null | undefined): string {
  return String(roleCode || '')
    .trim()
    .toUpperCase();
}

export function isExcludedFromEmployeeForm(
  roleCode: string | null | undefined,
): boolean {
  const normalized = normalizeRoleCode(roleCode);
  return (EMPLOYEE_FORM_EXCLUDED_ROLE_CODES as readonly string[]).includes(
    normalized,
  );
}

export function isExcludedFromEmployeeCreate(
  roleCode: string | null | undefined,
): boolean {
  return isExcludedFromEmployeeForm(roleCode);
}

export function isExcludedFromEmployeeEdit(
  roleCode: string | null | undefined,
): boolean {
  return isExcludedFromEmployeeForm(roleCode);
}

export function filterRolesForEmployeeForm<T extends { roleCode: string }>(
  roles: readonly T[],
): T[] {
  return roles.filter(role => !isExcludedFromEmployeeForm(role.roleCode));
}

export function filterRolesForEmployeeCreate<T extends { roleCode: string }>(
  roles: readonly T[],
): T[] {
  return filterRolesForEmployeeForm(roles);
}

export function filterRolesForEmployeeEdit<T extends { roleCode: string }>(
  roles: readonly T[],
): T[] {
  return filterRolesForEmployeeForm(roles);
}
